import Queries from '../queries';

const {
    GET_SELECTED_FILTERS,
} = Queries;

export const typeDefs = `
    type SelectedValue {
        label: String!
        value: String!
    }

    type FilterSelection {
        fieldId: ID!
        name: String!
        type: String!
        comparator: String!
        displayName: String!
        logicalConjunctionOperator: String!
        values: [SelectionValue]
    }
`;

const Mutation = {
    setSelectedFilters: (_root, { selectedFilters }, { client }) => {

        const newFilters = [];

        selectedFilters.forEach((filter) => {

            filter.__typename = 'FilterSelection';
            filter.values.forEach((value) => {

                value.__typename = 'FieldValue';

            });

            newFilters.push(filter);

        });

        client.writeQuery({
            query: GET_SELECTED_FILTERS,
            data: { selectedFilters: newFilters },
        });

        return newFilters;

    },
    addSelectedFilter: (_root, { filter }, { client, getCacheKey }) => {

        let { selectedFilters: prevFilters } = client.readQuery({ query: GET_SELECTED_FILTERS });

        const newFilters = [...prevFilters];

        const index = newFilters.findIndex(({ fieldId, type }) => (
            fieldId === filter.fieldId
            && type === filter.type
        ));

        filter.__typename = 'FilterSelection';
        filter.values.forEach((value) => {

            value.__typename = 'FieldValue';

        });

        if (index === -1) {

            newFilters.push(filter);

        } else {

            newFilters[index] = filter;

        }

        client.writeQuery({
            query: GET_SELECTED_FILTERS,
            data: { selectedFilters: newFilters },
        });

        return newFilters;

    },
    clearSelectedFilters: (_root, data, { client }) => {

        client.writeQuery({
            query: GET_SELECTED_FILTERS,
            data: { selectedFilters: [] },
        });

        return [];

    },
    removeSelectedFilter: (_root, { fieldName, value }, { client }) => {

        const { selectedFilters } = client.readQuery({ query: GET_SELECTED_FILTERS });

        const newFilters = selectedFilters.reduce((acc, field) => {

            if (field.name !== fieldName) {

                acc.push(field);
                return acc;

            }

            const newField = { ...field };
            newField.values = newField.values.filter(x => x.value !== value);

            if (newField.values.length > 0) {

                acc.push(newField);

            }

            return acc;

        }, []);

        client.writeQuery({
            query: GET_SELECTED_FILTERS,
            data: { selectedFilters: [...newFilters] },
        });

        return newFilters;

    },
};

export const resolvers = {
    Mutation,
};
